import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const QUOTES = [
  { text: "Barique makes couture feel personal, like heirloom. It is the label modern brides ask for.", by: "Vogue India" },
  { text: "There is a quiet confidence to the craft — restrained, intentional, unmistakably Delhi.", by: "Harper's Bazaar" },
  { text: "Every fitting felt like an atelier visit in Paris. I have never felt more myself in a lehenga.", by: "Isha K, Bride 2026" },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 bg-ink text-ivory" data-testid="testimonials">
      <div className="container-lux max-w-4xl text-center">
        <p className="overline text-ivory/50">In Praise Of Craft</p>
        <Swiper modules={[Autoplay, Pagination]} loop autoplay={{ delay: 5500 }} pagination={{ clickable: true }} className="mt-12">
          {QUOTES.map((q, i) => (
            <SwiperSlide key={i}>
              <blockquote className="font-serif italic font-light text-3xl md:text-5xl tracking-tight leading-tight">“{q.text}”</blockquote>
              <p className="mt-10 overline text-ivory/60">— {q.by}</p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
